import { EMAIL_LWK_GO_TO_FAILURE_STATE, EMAIL_LWK_GO_TO_INITIAL_STATE, EMAIL_LWK_GO_TO_SUCCESS_STATE } from '../actions/actionTypes';
import { emailLwkFailureState, emailLwkInitialState, emailLwkSuccessState } from '../types/EmailLwkUiState';
var emailLwkReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    if (action.type === EMAIL_LWK_GO_TO_INITIAL_STATE) {
        return emailLwkInitialState;
    }
    if (action.type === EMAIL_LWK_GO_TO_SUCCESS_STATE) {
        return emailLwkSuccessState;
    }
    if (action.type === EMAIL_LWK_GO_TO_FAILURE_STATE) {
        return emailLwkFailureState;
    }
    return state;
};
export default emailLwkReducer;
